module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/208.8d015ac8.png";